import React from 'react';

// Componente para prefetch de rotas (placeholder)
const RoutePrefetch: React.FC = () => {
  // Aqui pode ser implementada lógica de prefetch de rotas para performance
  return null;
};

export default RoutePrefetch;
